/**
 * Cents in, string out. The only place a number becomes money on screen.
 *
 * Cents everywhere else, always integers: the moment an amount becomes a
 * float somebody loses a penny and the ledger's zero-sum trigger rejects the
 * write. That is a database error at send time, not a rounding cosmetic.
 */

const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

export function money(cents: number): string {
  return usd.format(cents / 100)
}

/** "$36" when it is whole, "$36.50" when it is not. For dense lists. */
export function moneyShort(cents: number): string {
  return cents % 100 === 0
    ? usd.format(cents / 100).replace('.00', '')
    : usd.format(cents / 100)
}

/** '$36.00', '36', '1,234.5' -> integer cents. NaN when it is not a number. */
export function parseAmount(text: string): number {
  const cleaned = text.replace(/[$,\s]/g, '')
  if (!cleaned) return NaN
  const value = Number(cleaned)
  if (!Number.isFinite(value) || value < 0) return NaN
  return Math.round(value * 100)
}
